import { SUPPORTED_BROWSERS } from 'mk/autogenerated/supportedBrowsers';
import UAParser from 'ua-parser-js';

function splitVersion(version) {
    return version.split('.').map(parseFloat);
}

function compareVersion(version1, version2) {
    let maxLength = Math.max(version1.length, version2.length);
    for (let i = 0; i < maxLength; i++) {
        let res = version1[i] - version2[i];
        if (res) {
            return res;
        }
    }

    return 0;
}

function isAllowed(version, minOrExact, max) {
    let current = splitVersion(version);
    if (max === undefined) {
        // Exact match or bigger
        let exact = splitVersion(minOrExact);
        return compareVersion(current, exact) >= 0;
    } else {
        let minimum = splitVersion(minOrExact);
        let maximum = splitVersion(max);
        return compareVersion(current, minimum) >= 0 && compareVersion(current, maximum) <= 0;
    }
}

export function isSupported(userAgent) {
    let parser = new UAParser();
    parser.setUA(userAgent);

    let result = parser.getResult();
    let os = result.os.name.toLowerCase();
    let osVersion = result.os.version;
    let browser = result.browser.name.toLowerCase();
    let version = result.browser.version;

    let code;

    if (os === 'android' && osVersion && osVersion[0] === '4') {
        // Android 4 WebView cannot be changed
        code = 'android';
        version = result.os.version;
    } else if (os === 'ios') {
        // All iOS are using safari
        code = 'ios_saf';
        version = result.os.version;
    } else { // Others
        code = browser;
    }

    for (let i = 0; i < SUPPORTED_BROWSERS.length; i++) {
        let currentBrowser = SUPPORTED_BROWSERS[i];

        let parts = currentBrowser.split(' ');
        if (parts[0] !== code) {
            continue;
        }

        let range = parts[1].split('-');
        if (isAllowed(version, range[0], range[1])) {
            return true;
        }
    }

    return false;
}
